export const SHOW_CALENDAR_LABEL = 'Show Calendar'
export const CLOSE_CALENDAR_LABEL = 'Close Calendar'
export const SCHEDULES_AND_CLOSURES_TITLE = 'Schedules & Closures'
